import React from "react";

const VerifyInstructions = () => {
    return (
        <div className="tableWrapper">
            <div className="b-b"></div>
            <div className="row">
                <div className="col-md-12 n-p-50">
                    <div className="notice caption-small">
                        <div className={"mb-2"}><b style={{fontSize: 'large'}}>How to Verify Downloaded File with the
                            provided Signature and Public Key:</b></div>
                        <div className={"mb-2"}><b style={{fontSize: 'small'}}>Use gpg (linux) or <a
                            href="https://www.gpg4win.org/" style={{ color: '#024ad8' }}>Gpg4win</a> (Windows) example:</b></div>
                        <div>
                            Import public key: <code style={{fontFamily: 'monospace'}}>gpg --import
                            HP_ReuSecure_Reference_Firmware.x.x.x.zip.pub</code>
                        </div>
                        <div>
                            Find public key uid: <code style={{fontFamily: 'monospace'}}>gpg --list-keys</code>
                        </div>
                        <div>
                            Trust the public key: <code style={{fontFamily: 'monospace'}}>gpg --edit-key
                            "Public_key_uid_from_last_step"</code>
                        </div>
                        <div>
                            For the next prompt, type: <code style={{fontFamily: 'monospace'}}>trust</code>
                        </div>
                        <div>
                            For the trust level, enter: <code style={{fontFamily: 'monospace'}}>5</code> (ultimate
                            trust). Then confirm with <code style={{fontFamily: 'monospace'}}>y</code>
                        </div>
                        <div>
                            To quit edit, type: <code style={{fontFamily: 'monospace'}}>quit</code>
                        </div>
                        <div>
                            Check gpg key: <code style={{fontFamily: 'monospace'}}>gpg --verify
                            HP_ReuSecure_Reference_Firmware.x.x.x.zip.asc
                            HP_ReuSecure_Reference_Firmware.x.x.x.zip</code>
                        </div>
                        <div>
                            If the file has been verified you will see: <code style={{fontFamily: 'monospace'}}>Good signature for </code>"public key information"<code> [ultimate]</code>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyInstructions;
